const smartieToShopifyId = new Map();
let lastWishlistCount = null;
let lastCartCount = null;
let empathyScriptLoaded = false;
let empathyInitDone = false;
let empathyPdpAttribution = null;
let empathyPdpProductId = null;

(function readEmpathyPdpAttribution() {
  if (!window.EmpathyConfig?.isProductPage) return;
  try {
    const key = 'x-add-to-cart-' + window.location.pathname;
    const raw = window.localStorage.getItem(key);
    if (!raw) return;
    const record = JSON.parse(raw);
    if (isEmpathyAttributionExpired(record)) return;
    empathyPdpAttribution = record;
    empathyPdpProductId = findEmpathyProductId(empathyPdpAttribution) || window.EmpathyConfig.productSku || null;
  } catch (e) {
    empathyPdpAttribution = null;
  }
})();

function findEmpathyValue(value, keys, expectedType, depth) {
  if (!value || typeof value !== 'object' || (depth || 0) > 10) return undefined;
  for (let i = 0; i < keys.length; i++) {
    if (typeof value[keys[i]] === expectedType) return value[keys[i]];
  }
  const objectKeys = Object.keys(value);
  for (let i = 0; i < objectKeys.length; i++) {
    const found = findEmpathyValue(value[objectKeys[i]], keys, expectedType, (depth || 0) + 1);
    if (found !== undefined) return found;
  }
  return undefined;
}

function findEmpathyProductId(value) {
  return findEmpathyValue(value, ['productId'], 'string') || null;
}

function isEmpathyAttributionExpired(record) {
  return typeof record?.ttl === 'number' && Date.now() > record.ttl;
}

window.addEventListener('wishlist:init', function (e) {
  lastWishlistCount = e.detail.count;
});

window.addEventListener('wishlist:change', function (e) {
  lastWishlistCount = e.detail.count;
  const sr = document.querySelector('.x-root-container')?.shadowRoot;
  if (sr) updateEmpathyWishlistBadge(sr, e.detail.count);
});

document.addEventListener('DOMContentLoaded', function () {
  document.querySelectorAll('a[href="#empathy-search"]').forEach(function (empathyLink) {
    empathyLink.addEventListener('click', function (event) {
      event.preventDefault();
      event.stopPropagation();
      loadAndOpenEmpathy();
    });
  });

  // Empathy X maneja nativamente el parámetro ?query= de la URL (abre + ejecuta la
  // búsqueda). Como el SDK se carga on-demand, aquí solo forzamos su carga cuando la
  // página llega con ?query= para que su manejo nativo se dispare.
  const hasDeepLinkQuery = new URLSearchParams(window.location.search).get('query')?.trim();
  if (hasDeepLinkQuery) {
    loadAndOpenEmpathy();
  }
});

if (empathyPdpAttribution) {
  const loadEmpathyForPdp = function () {
    ensureEmpathyScriptLoaded(function () {
      runEmpathyInit({ isSPA: false, productId: empathyPdpProductId });
    });
  };

  if (typeof window.requestIdleCallback === 'function') {
    window.requestIdleCallback(loadEmpathyForPdp);
  } else {
    setTimeout(loadEmpathyForPdp, 200);
  }

  subscribe(PUB_SUB_EVENTS.cartUpdate, function (event) {
    if (event?.source !== 'product-form') return;
    try {
      if (window.InterfaceX && typeof window.InterfaceX.addProductToCart === 'function') {
        window.InterfaceX.addProductToCart(empathyPdpProductId);
      }
    } catch (e) {}
  });
}

function getEmpathyScope() {
  const uaData = navigator.userAgentData;
  if (typeof uaData?.mobile === 'boolean') {
    return uaData.mobile ? 'mobile' : 'desktop';
  }
  const uaMobile = /Android|iPhone|iPad|iPod|Mobile|Opera Mini|IEMobile/i.test(navigator.userAgent);
  const hasTouch = navigator.maxTouchPoints > 0;
  return uaMobile || hasTouch ? 'mobile' : 'desktop';
}

function ensureEmpathyScriptLoaded(onReady) {
  function waitForInterfaceX() {
    if (window.InterfaceX) {
      onReady();
      return;
    }
    let attempts = 0;
    const t = setInterval(function () {
      if (window.InterfaceX) {
        clearInterval(t);
        onReady();
      } else if (++attempts > 100) {
        clearInterval(t);
      }
    }, 50);
  }

  if (window.InterfaceX) {
    onReady();
    return;
  }

  if (!empathyScriptLoaded) {
    empathyScriptLoaded = true;
    const s = document.createElement('script');
    s.type = 'module';
    s.src = 'https://x.empathy.co/x-jlj/app.js';
    s.addEventListener('load', waitForInterfaceX);
    s.addEventListener('error', function () { empathyScriptLoaded = false; });
    document.head.appendChild(s);
  } else {
    waitForInterfaceX();
  }
}

function loadAndOpenEmpathy() {
  if (window.InterfaceX?.bus) {
    window.InterfaceX.bus.emit('UserClickedOpenX', {});
    return;
  }

  function openWhenBusReady() {
    let attempts = 0;
    const t = setInterval(function () {
      if (window.InterfaceX?.bus) {
        clearInterval(t);
        window.InterfaceX.bus.emit('UserClickedOpenX', {});
      } else if (++attempts > 100) {
        clearInterval(t);
      }
    }, 50);
  }

  ensureEmpathyScriptLoaded(function () {
    runEmpathyInit();
    openWhenBusReady();
  });
}

function runEmpathyInit(options) {
  if (empathyInitDone) return;
  empathyInitDone = true;

  const { lang, store, currency } = window.EmpathyConfig;

  const initConfig = {
    instance: 'jlj',
    scope: getEmpathyScope(),
    lang,
    store,
    currency,
    consent: false
  };
  if (options?.isSPA !== undefined) initConfig.isSPA = options.isSPA;
  if (options?.productId) initConfig.productId = options.productId;

  window.InterfaceX.init(initConfig);

  fetch((window.Shopify?.routes?.root || '/') + 'cart.js')
    .then(function (r) { return r.json(); })
    .then(function (cart) {
      lastCartCount = cart.item_count || null;
      const sr = document.querySelector('.x-root-container')?.shadowRoot;
      if (sr) updateEmpathyCartBadge(sr, lastCartCount);
    });

  subscribe(PUB_SUB_EVENTS.cartUpdate, function (event) {
    const count = event.cartData?.item_count;
    if (count !== undefined) {
      lastCartCount = count || null;
      const sr = document.querySelector('.x-root-container')?.shadowRoot;
      if (sr) updateEmpathyCartBadge(sr, lastCartCount);
    } else {
      fetch((window.Shopify?.routes?.root || '/') + 'cart.js')
        .then(function (r) { return r.json(); })
        .then(function (cart) {
          lastCartCount = cart.item_count || null;
          const sr = document.querySelector('.x-root-container')?.shadowRoot;
          if (sr) updateEmpathyCartBadge(sr, lastCartCount);
        });
    }
  });

  const waitForBus = setInterval(function () {
    if (window.InterfaceX.bus) {
      clearInterval(waitForBus);

      const sr = document.querySelector('.x-root-container')?.shadowRoot;
      if (sr) watchEmpathyShadowRoot(sr);

      if (!sr) {
        const bodyObserver = new MutationObserver(function () {
          const el = document.querySelector('.x-root-container');
          if (el && el.shadowRoot) {
            bodyObserver.disconnect();
            watchEmpathyShadowRoot(el.shadowRoot);
          }
        });
        bodyObserver.observe(document.body, { childList: true, subtree: true });
      }

      window.InterfaceX.bus.on('UserClickedResultAddToCart').subscribe(async function (product) {
        const productData = await fetchEmpathyProductData(product);
        if (!productData) return;
        if (productData.variants.length === 1) {
          await addToShopifyCart(productData.variants[0].id);
        } else {
          var productUrl = productData.url || (window.Shopify?.routes?.root || '/') + 'products/' + productData.handle;
          renderEmpathyQuickAddModal(productUrl);
        }
      });

      async function persistWishlist() {
        try {
          const stored = localStorage.getItem('wishlist');
          if (!stored) return;
          const data = JSON.parse(stored);
          if (!data.customerId) return;
          const ids = (await window.Wishlistr.getIds()).map(String);
          const payload = {
            customer: data.customerId,
            namespace: 'custom',
            key: 'wishlist',
            metafieldId: data.metafieldId || '',
            ids
          };
          await fetch('/apps/wishlist/save?param=' + btoa(JSON.stringify(payload)));
        } catch (e) {}
      }

      window.InterfaceX.bus.on('UserClickedResultWishlist').subscribe(async function (product) {
        if (!window.Wishlistr) {
          console.warn('[empathy] window.Wishlistr not available');
          return;
        }
        try {
          const productData = await fetchEmpathyProductData(product);
          if (!productData) return;
          smartieToShopifyId.set(String(product.id), productData.id);
          const isInWishlist = await window.Wishlistr.check(productData.id);
          if (isInWishlist) {
            await window.Wishlistr.remove(productData.id);
            showEmpathyToast(window.EmpathyConfig.wishlistRemovedText);
          } else {
            await window.Wishlistr.add(productData.id);
            showEmpathyToast(window.EmpathyConfig.wishlistAddedText);
          }
          await persistWishlist();
          const currentSr = document.querySelector('.x-root-container')?.shadowRoot;
          if (currentSr) setCardWishlistState(currentSr, String(product.id), !isInWishlist);
        } catch (e) {
          console.error('[empathy] wishlist error:', e);
        }
      });
    }
  }, 200);
}

function injectShadowStyles(sr) {
  if (sr.querySelector('#empathy-injected-styles')) return;
  const style = document.createElement('style');
  style.id = 'empathy-injected-styles';
  style.textContent = '.empathy-wishlisted path { fill: currentColor; } [aria-label="Go to wishlist page"], [aria-label="Go to add to cart page"] { position: relative; display: inline-flex; align-items: center; justify-content: center; width: 26px; height: 26px; } [aria-label="Go to wishlist page"] svg { width: 22px; height: 22px; } [aria-label="Go to wishlist page"] svg path { stroke-width: 1.3; } [aria-label="Go to add to cart page"] svg { width: 26px; height: 26px; } #empathy-wishlist-badge, #empathy-cart-badge { position: absolute; top: -4px; right: -6px; background: transparent; color: #000; font-size: 10px; font-weight: 400; line-height: 1; pointer-events: none; min-width: 10px; text-align: center; }';
  sr.appendChild(style);
}

function updateEmpathyWishlistBadge(sr, count) {
  const btn = sr.querySelector('[aria-label="Go to wishlist page"]');
  if (!btn) return;
  const existing = btn.querySelector('#empathy-wishlist-badge');
  if (!count) {
    if (existing) existing.remove();
    return;
  }
  if (existing && existing.textContent === String(count)) return;
  const badge = existing || document.createElement('div');
  if (!existing) {
    badge.id = 'empathy-wishlist-badge';
    btn.appendChild(badge);
  }
  badge.textContent = count;
}

function updateEmpathyCartBadge(sr, count) {
  const btn = sr.querySelector('[aria-label="Go to add to cart page"]');
  if (!btn) return;
  const existing = btn.querySelector('#empathy-cart-badge');
  if (!count) {
    if (existing) existing.remove();
    return;
  }
  if (existing && existing.textContent === String(count)) return;
  const badge = existing || document.createElement('div');
  if (!existing) {
    badge.id = 'empathy-cart-badge';
    btn.appendChild(badge);
  }
  badge.textContent = count;
}

function setCardWishlistState(sr, smartieId, isWishlisted) {
  const card = sr.querySelector('[data-wysiwyg-id="' + smartieId + '"]');
  if (!card) return;
  const heartBtn = card.querySelector('.x-button.x-button-md.x-button-tight.x-mt-2');
  if (!heartBtn) return;
  heartBtn.classList.toggle('empathy-wishlisted', isWishlisted);
}

function showEmpathyToast(message) {
  let toast = document.getElementById('empathy-toast');
  if (!toast) {
    toast = document.createElement('div');
    toast.id = 'empathy-toast';
    document.body.appendChild(toast);
  }
  toast.textContent = message;
  toast.className = 'empathy-toast empathy-toast--visible';
  clearTimeout(toast._timeout);
  toast._timeout = setTimeout(function () {
    toast.classList.remove('empathy-toast--visible');
  }, 3000);
}

function closeEmpathyModal() {
  const sr = document.querySelector('.x-root-container')?.shadowRoot;
  if (!sr) return;
  sr.querySelector('.x-close-button, [class*="close"], button[aria-label*="lose"], .x-search__close-button')?.click();
}

async function addToShopifyCart(variantId) {
  const cartEl = document.querySelector('cart-drawer') || document.querySelector('cart-notification');
  const formData = new FormData();
  formData.append('id', variantId);
  formData.append('quantity', 1);
  const sections = cartEl ? cartEl.getSectionsToRender().map(function (s) { return s.id; }) : [];
  if (cartEl) {
    formData.append('sections', sections);
    formData.append('sections_url', window.location.pathname);
    cartEl.setActiveElement(document.activeElement);
  }
  const res = await fetch((window.Shopify?.routes?.root || '/') + 'cart/add.js', {
    method: 'POST',
    headers: { 'X-Requested-With': 'XMLHttpRequest' },
    body: formData
  });
  if (!res.ok) {
    showEmpathyToast(window.EmpathyConfig.soldOutText);
    return;
  }
  let response;
  try {
    response = await res.json();
  } catch (e) {
    response = null;
  }
  if (response && response.status) {
    showEmpathyToast(window.EmpathyConfig.soldOutText);
    return;
  }
  closeEmpathyModal();
  if (cartEl && response && response.sections) {
    cartEl.renderContents(response);
    cartEl.classList.remove('is-empty');
  } else if (cartEl) {
    fetch(window.location.pathname + '?sections=' + sections.join(','))
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (sectionsData) {
        if (sectionsData) {
          cartEl.renderContents({ sections: sectionsData });
          cartEl.classList.remove('is-empty');
        } else {
          publish(PUB_SUB_EVENTS.cartUpdate, { source: 'empathy-search', cartData: response });
          cartEl.open();
        }
      });
  }
  fetch((window.Shopify?.routes?.root || '/') + 'cart.js')
    .then(function (r) { return r.json(); })
    .then(function (cart) {
      lastCartCount = cart.item_count || null;
      const sr = document.querySelector('.x-root-container')?.shadowRoot;
      if (sr) updateEmpathyCartBadge(sr, lastCartCount);
    });
}

async function searchShopifyProduct(query) {
  const searchRes = await fetch(
    window.routes.predictive_search_url + '.json?q=' + encodeURIComponent(query) +
    '&resources[type]=product&resources[limit]=1&section_id=predictive-search'
  );
  if (!searchRes.ok) return null;
  const data = await searchRes.json();
  const handle = data.resources?.results?.products?.[0]?.handle;
  if (!handle) return null;
  const root = window.Shopify?.routes?.root || '/';
  const productRes = await fetch(root + 'products/' + handle + '.js');
  if (!productRes.ok) return null;
  return productRes.json();
}

async function fetchEmpathyProductData(product) {
  if (product.url) {
    const handle = product.url.split('/products/')[1]?.split('?')[0];
    if (handle) {
      const root = window.Shopify?.routes?.root || '/';
      const res = await fetch(root + 'products/' + handle + '.js');
      if (res.ok) {
        const data = await res.json();
        if (data && !data.status) return data;
      }
    }
  }
  const result = await searchShopifyProduct(product.name);
  if (result) return result;
  const ctMatch = product.name.match(/(\d+[.,]\d+)\s*ct/i);
  if (!ctMatch) return null;
  const ct = ctMatch[1].replace(',', '.');
  return searchShopifyProduct('diamante natural ' + ct);
}

function renderEmpathyQuickAddModal(productUrl) {
  document.querySelectorAll('quick-add-modal.empathy-quick-add-modal').forEach(function (el) {
    el.remove();
  });

  const url = new URL(
    productUrl.startsWith('/') ? window.location.origin + productUrl : productUrl
  );
  url.searchParams.set('view', 'modal-quick-add');

  fetch(url)
    .then(function (response) { return response.text(); })
    .then(function (responseText) {
      const responseHTML = new DOMParser().parseFromString(responseText, 'text/html');
      var productQuickAdd = responseHTML.querySelector('.section--product-modal-quick-add');
      if (!productQuickAdd) return;

      productQuickAdd.querySelector('quick-add-modal')?.classList.remove('quick-add-modal-section');

      var sectionId = productQuickAdd.querySelector('quick-add-modal')?.dataset.section;
      if (sectionId) {
        productQuickAdd.innerHTML = productQuickAdd.innerHTML.replaceAll(sectionId, 'empathy-' + sectionId);
        productQuickAdd.querySelectorAll('variant-selects, product-info').forEach(function (el) {
          el.dataset.originalSection = sectionId;
        });
      }

      var modal = productQuickAdd.querySelector('quick-add-modal');
      if (modal) modal.classList.add('empathy-quick-add-modal');

      var scripts = Array.from(productQuickAdd.querySelectorAll('script'));

      var nestedModals = Array.from((modal || productQuickAdd).querySelectorAll('.content-popup-modal'));
      var nestedWrappers = nestedModals.map(function (m) {
        var wrapper = document.createElement('div');
        wrapper.className = 'shopify-section';
        wrapper.appendChild(m);
        return wrapper;
      });

      document.body.appendChild(productQuickAdd);

      nestedWrappers.forEach(function (wrapper) {
        document.body.appendChild(wrapper);
      });

      scripts.filter(function (tag) { return !tag.classList.contains('klaviyo-skip-script'); })
        .forEach(function (scriptTag) {
          var newScript = document.createElement('script');
          Array.from(scriptTag.attributes).forEach(function (attr) {
            newScript.setAttribute(attr.name, attr.value);
          });
          newScript.appendChild(document.createTextNode(scriptTag.innerHTML));
          document.body.appendChild(newScript);
        });

      if (window.Shopify && Shopify.PaymentButton) Shopify.PaymentButton.init();
      if (window.ProductModel) window.ProductModel.loadShopifyXR();

      var variantPicker = modal ? modal.querySelector('variant-selects') : null;
      if (variantPicker) variantPicker.setAttribute('data-update-url', 'false');

      setTimeout(function () {
        if (modal) modal.show();
      }, 300);
    });
}

async function syncWishlistStates(sr) {
  if (!window.Wishlistr || smartieToShopifyId.size === 0) return;
  const wishlistIds = await window.Wishlistr.getIds();
  const wishlistSet = new Set(wishlistIds.map(String));
  smartieToShopifyId.forEach(function (shopifyId, smartieId) {
    setCardWishlistState(sr, smartieId, wishlistSet.has(String(shopifyId)));
  });
}

function watchEmpathyShadowRoot(sr) {
  injectShadowStyles(sr);
  let syncTimeout;
  function attachToButtons() {
    const wishBtn = sr.querySelector('[aria-label="Go to wishlist page"]');
    if (wishBtn && !wishBtn._empathyHandled) {
      wishBtn._empathyHandled = true;
      wishBtn.addEventListener('click', function (e) {
        e.preventDefault();
        e.stopPropagation();
        closeEmpathyModal();
        window.location.href = (window.Shopify?.routes?.root || '/') + 'pages/wishlist';
      });
    }
    const cartBtn = sr.querySelector('[aria-label="Go to add to cart page"]');
    if (cartBtn && !cartBtn._empathyHandled) {
      cartBtn._empathyHandled = true;
      cartBtn.addEventListener('click', function (e) {
        e.preventDefault();
        e.stopPropagation();
        closeEmpathyModal();
        setTimeout(function () {
          const cartEl = document.querySelector('cart-drawer');
          if (cartEl) cartEl.open();
        }, 300);
      });
    }
  }

  attachToButtons();
  updateEmpathyWishlistBadge(sr, lastWishlistCount);
  updateEmpathyCartBadge(sr, lastCartCount);
  new MutationObserver(function () {
    attachToButtons();
    updateEmpathyWishlistBadge(sr, lastWishlistCount);
    updateEmpathyCartBadge(sr, lastCartCount);
    clearTimeout(syncTimeout);
    syncTimeout = setTimeout(function () { syncWishlistStates(sr); }, 300);
  }).observe(sr, { childList: true, subtree: true });
}
